import { render, staticRenderFns } from "./TechGenerator.vue?vue&type=template&id=3acb1562"
import script from "./TechGenerator.vue?vue&type=script&lang=js"
export * from "./TechGenerator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports